'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _functional = require('../utils/functional');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ProductReviews = function () {
  function ProductReviews(el) {
    (0, _classCallCheck3.default)(this, ProductReviews);

    this.els = {
      el: el,
      container: (0, _functional.getElement)('[data-module-product-reviews-container]')
    };

    this.handleWidgetLoad = this.handleWidgetLoad.bind(this);

    this.setupListeners();
  }

  (0, _createClass3.default)(ProductReviews, [{
    key: 'setupListeners',
    value: function setupListeners() {
      if (this.els.container && window.feefoWidgetInstanceConfig) {
        window.addEventListener('load', this.handleWidgetLoad);
      }
    }
  }, {
    key: 'handleWidgetLoad',
    value: function handleWidgetLoad() {
      var _this = this;

      setTimeout(function () {
        var feefoWidgetLength = _this.els.container.shadowRoot.childNodes[0].childNodes.length;

        if (feefoWidgetLength <= 0) {
          _this.els.el.setAttribute('aria-hidden', true);
        }
      }, 3000);
    }
  }]);
  return ProductReviews;
}();

exports.default = ProductReviews;